// extracted by mini-css-extract-plugin
export default {"header":"DashboardHeader_header__59hgp","user":"DashboardHeader_user__L6EUL","actions":"DashboardHeader_actions__hhWcm","iconBtn":"DashboardHeader_iconBtn__v0Bv3"};